import { searchConstants } from './creator';
import { SortingOptions } from '../../../constant/search';

export const searchModuleInitialState = {
  form: { sort_attrs: SortingOptions[0] },
  results: { loading: false },
};

const MAPPED_REDUCERS = {
  [searchConstants.SET_FORM_DATA]: (state, { payload, meta = {} }) => ({
    ...state,
    form: {
      ...(meta.update && state.form),
      ...payload,
    },
  }),
  [searchConstants.RESET_FORM_DATA]: (state) => ({
    ...state,
    form: searchModuleInitialState.form,
  }),
  [searchConstants.SET_SEARCH_RESULTS]: (state, { payload: results, meta = {} }) => ({
    ...state,
results: {
      ...(meta.update && state.results),
      loading: false,
      ...results,
    },

  }),

  [searchConstants.APPEND_CANDIDATES]: (state, { payload }) => ({
    ...state,
    results: {
      ...state.results,
      candidates: [...state.results.candidates, ...payload.candidates],
      loading: false,
    },
  }),
  [searchConstants.UPDATE_FILTERS]: (state, { payload }) => ({
    ...state,
    results: {
      ...state.results,
      facets: {
        ...state.results.facets,
        ...payload,
      },
    },
  }),
};

// eslint-disable-next-line default-param-last
function searchReducer(state = searchModuleInitialState, action) {
  const handler = MAPPED_REDUCERS[action.type];

  return handler ? handler(state, action) : state;
}

export default searchReducer;
